export enum UserLoginType {
  PASSWORD,
  GMAIL,
}
